import '../../../assets/css/import_files_page.css';
import React, { useCallback, useEffect, useState } from "react";
import * as XLSX from "xlsx";

import Radio from '@mui/material/Radio';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Backdrop from '@mui/material/Backdrop';
import swal from 'sweetalert';
import CircularProgress from '@mui/material/CircularProgress';

import Papa from "papaparse";

import My_dropzone from "./drag_drop_files_zone/drag_drop_files_zone";
import Files_table from './files_table/files_table';
import { load_catalogue_fromFiles, get_imported_files } from '../../../services/supplier_service';
import { get_suppliers } from '../../../services/for_allServices';
import { get_all_categories, get_categories, upload_suppliers_catalogues } from '../../../services/company_admin_service';


function bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}



function Import_reason_container({ import_reason, change_import_reason, reason_elem, download_model }) {
    return (
        <div className={import_reason !== reason_elem ? 'imp_res_container' : 'imp_res_container imp_res_container_slected'}
            onClick={() => change_import_reason(reason_elem)} >
            <div className='imp_res_radio'> <Radio size="small" color="info" checked={import_reason === reason_elem ? true : false} /> </div>
            <div className='imp_res_icon'> <AddBusinessIcon /> </div>
            <div className='imp_res_title'> Importer le catalogue de vos produits </div>
            <div className='flex_container_center'>
                <span style={{ textDecoration: "underLine", color: "blue", cursor: "pointer" }} onClick={download_model}>Télécharger le modèle</span>
            </div>
        </div>
    );
}


const columns = [
    { id: 'type', label: "Type de fichier", minWidth: 0, align: 'left' },
    { id: 'name', label: "Nom de fichier", minWidth: 0, align: 'left' },
    { id: 'size', label: "Taille de fichier", minWidth: 0, align: 'left' },
];



function Selected_files_table({ files_data }) {

    return (
        <>
            <TableContainer className="files_table_container" component={Paper}>
                <Table aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {
                                columns.map((column) => (
                                    <TableCell key={column.id} align={column.align}>{column.label}</TableCell>
                                ))
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            files_data.length !== 0
                                ?
                                <>
                                    {
                                        files_data.map((file, id) => (
                                            <TableRow key={"file_col" + id}>
                                                <TableCell align="left">{"fichier " + file.path.split('.')[file.path.split('.').length - 1]}</TableCell>
                                                <TableCell align="left">{file.path}</TableCell>
                                                <TableCell align="left">{bytesToSize(file.size)}</TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </>
                                : <div style={{ margin: "10px", fontSize: ".8rem", width: '100%', textAlign: "center", alignContent: "center" }}>Aucun fichier déposer</div>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}





function Import_files_page() {

    const excel_header_fr = ["fournisseur", "code produit", "titre", "prix du produit", "Famille d'achat", "description"];
    const excel_header_eng = ["supplier", "code", "title", "price", "category", "description"];

    const catalogue_mandatory_headers = ["supplier", "code", "title", "price", "category"];
    const catalogue_headers_to_be_checked = ["supplier", "code", "title", "price", "category", "description"];

    const import_model_for_products = [{
        "supplier": 1,
        "code": "pr_model",
        "title": "Random Text",
        "price": 100000,
        "category": 2,
        "description": "Random text description"
    }];

    let connected_user = JSON.parse(localStorage.getItem('user-info'))

    const [import_reason, setImport_reason] = useState(null);
    const [selected_files, setSelected_files] = useState([]);
    const [existing_files, setExisting_files] = useState([]);

    const [file_content, setFile_content] = useState([]);
    const [uploaded_file, setUploaded_file] = useState(null);

    const [suppliers, setsuppliers] = useState([]);
    const [categories, setCategories] = useState([]);

    const [errorText, setErrorText] = useState("");
    const [waiting, setWaiting] = useState(false);

    const config = { delimiter: ";", header: true };

    useEffect(() => {
        const load_data = async () => {
            await get_suppliers().then((response) => {
                console.log(response.data);
                setsuppliers(response.data);
            }).catch((error) => {
                console.log(error.response);
            })
            await get_all_categories().then((response) => {
                console.log("categories", categories);
                setCategories(response.data);
            }).catch((error) => {
                console.log(error.response);
            });
        }
        load_data();
    }, []);

    const onDrop = useCallback((acceptedFiles) => {
        setErrorText('');
        let tmp_array = [...selected_files];
        if (acceptedFiles.length !== 0) {
            acceptedFiles.map((selected_file) => {
                //console.log(selected_file.path)
                tmp_array.push(selected_file);
            })
            setSelected_files(tmp_array);
            tmp_array.map((file) => import_csv_file(file))
        }
    }, []);

    function change_import_reason(reason) {
        console.log(reason);
        setImport_reason(reason);
        setExisting_files([]);
        let formData = new FormData();
        formData.append('id_login', connected_user.id);
        formData.append('imports_reason', reason);
        get_imported_files(formData).then((response) => {
            console.log(response.data);
            setExisting_files(response.data);
        }).catch((error) => {
            console.log(error.response);
        })
        setSelected_files([]);
    }

    function read_excel_data(data) {
        var wb = XLSX.read(data, { type: 'binary' });
        for (var i = 0; i < wb.SheetNames.length; i++) {
            const ws = wb.Sheets[wb.SheetNames[i]];
            const content = XLSX.utils.sheet_to_csv(ws, { header: 1 });
            const content_headers = (content.split('\n')[0]).split(',');
            for (var j = 0; j < content_headers.length; j++) {
                if (!excel_header_fr.includes(content_headers[j]) && !excel_header_eng.includes(content_headers[j])) {
                    return false;
                }
            }
        }
        return true;
    }


    async function import_csv_file(file) {
        setWaiting(true);
        setFile_content([]);
        setUploaded_file(file);
        const reader = new FileReader();
        reader.onload = async ({ target }) => {
            const csv = await Papa.parse(target.result, {
                header: true,
            });
            const tmp_data = csv?.data;
            const file_header = Object.keys(tmp_data[0]);
            let nonexisting_headers = catalogue_headers_to_be_checked.filter((elem) => {
                return !file_header.includes(elem);
            });
            console.log(nonexisting_headers);
            let msg_error = "";
            for (let non_existing_column of nonexisting_headers) {
                if (msg_error == "") msg_error += "Colonne inexistante : " + non_existing_column;
                else msg_error += "," + non_existing_column;
            }
            //seterrorText(msg_error);
            let taken_data = [];
            let data_to_be_taken = true;
            for (let product of tmp_data) {
                data_to_be_taken = true;
                for (let header of catalogue_mandatory_headers) {
                    if (!product.hasOwnProperty(header)) {
                        data_to_be_taken = false;
                        break;
                    }
                }
                if (data_to_be_taken) {
                    taken_data.push(product);
                }
            }
            console.log("parsedData", taken_data);
            await setFile_content(taken_data);
            setWaiting(false);
        };
        reader.readAsText(file);
    }

    async function submit_to_save_content(){
        setWaiting(true);
        let formData = new FormData();
        formData.append("id_login",connected_user.id);
        formData.append("data",JSON.stringify(file_content));
        formData.append("file",uploaded_file);
        await upload_suppliers_catalogues(formData).then((response)=>{
            console.log(response.data);
        }).catch((error)=>{
            console.log(error.response);
        });
        setWaiting(false);
    }


    async function submit_to_save_files_excel(files) {
        setErrorText('');
        var error = "";
        const filePromises = files.map((file) => {
            const reader = new FileReader();
            reader.onerror = (function (file, error) {
                return function (e) {
                    error = error + " \n la lecture du fichier ( " + file.name + " ) a échoué !";
                }
            })(file, error);

            reader.onload = function (file, error) {
                //console.log(error);
                return async function (e) {
                    let valide_to_save = true;
                    const binaryStr = e.target.result
                    valide_to_save = read_excel_data(binaryStr);
                    if (valide_to_save === false) {
                        setErrorText(error + ' les en-têtes de tableau ne sont pas acceptables fichier : ' + file.name);
                        error += 'les en-têtes de tableau ne sont pas acceptables fichier : ' + file.name;
                    } else {
                        setWaiting(true);
                        let formData = new FormData();
                        formData.append('files', file);
                        formData.append('id_supplier', connected_user.id);
                        await load_catalogue_fromFiles(formData).then((response) => {
                            let data = response.data;
                            if (Array.isArray(data)) {
                                setErrorText(error + ' <br /> ' + data[0]);
                                error += data[0];
                            } else {
                                let tmp_array_files = [...selected_files];
                                let tmp_existing_files = [...existing_files];
                                tmp_existing_files.push(data.imported);
                                setExisting_files(tmp_existing_files);
                                for (let j in tmp_array_files) {
                                    if (file.name === tmp_array_files[j].path) tmp_array_files.splice(j, 1);
                                }
                                swal("votre réponse a été enregistrée avec succès !", {
                                    icon: "success",
                                    buttons: true,
                                }).then((willDelete) => {
                                    if (willDelete) { }
                                })
                                setSelected_files(tmp_array_files);
                            }
                            setWaiting(false);
                        }).catch((error) => {
                            //console.log(error.response);
                            setWaiting(false);
                        })
                    }
                };
            }(file, error);
            reader.readAsBinaryString(file);
        })
        //console.log(error);
    }

    async function download_categories() {
        setWaiting(true);
        let data = [];
        let tmp_json = {};
        console.log(categories);
        for (let category of categories) {
            tmp_json = {};
            tmp_json["ID Catégorie"] = category.id_category;
            tmp_json["Catégorie"] = category.name;
            data.push(tmp_json);
        }
        const csvData = Papa.unparse(data, config);
        const filename = "categories.csv";
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setWaiting(false);
    }


    async function download_suppliers() {
        setWaiting(true);
        let data = [];
        let tmp_json = {};
        for (let supplier of suppliers) {
            tmp_json = {};
            tmp_json["ID Fournisseur"] = supplier.id;
            tmp_json["Fournisseur"] = supplier.fullName;
            tmp_json["Maison mère"] = supplier.parentCompany;
            data.push(tmp_json);
        }
        const csvData = Papa.unparse(data, config);
        const filename = "fournisseurs.csv";
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setWaiting(false);
    }

    async function download_model() {
        setWaiting(true);
        const csvData = Papa.unparse(import_model_for_products, config);
        console.log(csvData);
        const filename = "model.csv";
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setWaiting(false);
    }

    return (
        <div className="import_files_page_container">
            <div className='all_imp_res_container'>
                <div style={{ width: '100%' }}><span className='page_title zone_title' style={{ marginBottom: '10px' }}> Quel est l'objectif de votre importation ?</span></div>
                <Import_reason_container import_reason={import_reason} change_import_reason={change_import_reason} download_model={download_model} reason_elem="produits" />
            </div>
            <div className='flex_container_center'>
                <span style={{ textDecoration: "underLine", color: "blue", cursor: "pointer" }} onClick={download_categories}>Catégories</span>
                <span style={{ margin: "0 5px" }}>/</span>
                <span style={{ textDecoration: "underLine", color: "blue", cursor: "pointer" }} onClick={download_suppliers}>Fournisseurs</span>
            </div>
            <div className="drop_zone_container">
                <My_dropzone onDrop={onDrop} import_reason={import_reason} />
            </div>

            <div className='files__container'>
                <span className='zone_title' > Fichiers que vous ajouterez </span>
                <Selected_files_table files_data={selected_files} />
            </div>

            <div className='files__container' style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                {
                    errorText === ""
                        ? <></>
                        : <p className={errorText ? "error" : "valid-champ"}>
                            {errorText}
                        </p>
                }
                <Button variant="contained" className={selected_files.length !== 0 ? "submit_but" : 'submit_but disabled_button'}
                    onClick={() => submit_to_save_content()} startIcon={<AddIcon className="my_icon" />}>
                    Valider
                </Button>
            </div>

            <div className='files__container' style={{ margin: '35px auto' }}>
                <span className='zone_title'> Vos fichiers existants </span>
                <Files_table files_data={existing_files} />
            </div>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

        </div>

    );
}
export default Import_files_page;